import { api } from '../service/NetworkUtility';
import { logError } from './ErrorService';

export const RequestParameters = (company, startOn, endOn) => {
    return { company, startOn, endOn };
}

export const makeRequest = (request, successHandler) => {
    const { company, startOn, endOn } = request;

    if (company == null || typeof company === 'undefined') {
        return;
    }
    
    const url = `/companies/${company}/payments/types/ALL/summary/total?startOn=${startOn}&endOn=${endOn}`;
    api.get(url)
        .then(transformResponse)
        .then((data) => {
            successHandler(data.companyTotals);
        })
        .catch(function (error) {
            //navigate hook does not work here, using window.location to redirect
            if (error?.response?.status === 401 || error?.response?.status === 403) {
                //unauthorized user - log unauth attempt and redirect
                logError("Unauthorized user attempt", () => {
                    window.location = "/unauthorizedUser?po";
                });
            } else {
                //TODO: add an error handler to the caller of this
                console.log("Unable to retrieve Program Overview information.");
            }
        });
}

const transformResponse = (response) => {
    return response.data;
}